import React from 'react'
import { ReactComponent as CaretIcon } from '../../../../assets/src/lib/icons/arrows/arrDown.svg'

export const Caret = ({ className }: {className: string}): JSX.Element => <CaretIcon className={className} />
